// extracted by mini-css-extract-plugin
export default {"button":"styles_button__M-Uhx","flag":"styles_flag__OvGZO","active":"styles_active__jjVVm"};